/**
 * Entry point for webpack
 * Import styles, fonts, icons, scripts and other things that your project design requires here
 */

import barba from '@barba/core'
import NProgress from 'nprogress'
import isMobile from 'ismobilejs'
import 'regenerator-runtime/runtime'

import 'nprogress/nprogress.css'
import './styles/main.scss'
import './form/styles/form.scss'
import './styles/cta.scss'
import './styles/main-area-grid.scss'
import './styles/header.scss'
import './styles/popup-menu-animation.scss'
import './styles/typography.scss'
import './styles/newsletter-form.scss'
import './styles/offers.scss'
import './styles/person-card.scss'
import './styles/dropdown.scss'
import './styles/service-item.scss'
import './styles/private-office.scss'
import './styles/contact-person.scss'

import onPageLoad, { withVue } from './on-page-load'
import menu from './menu'
import proper100vh from './proper-100-vh'
import loadingAnimation from './loading-animation'
import stickyFooter from './sticky-footer'
import scrollProgress from './scroll-progress'
import scrollAnimations from './scroll-animations'
import form from './form'
import smoothScrollTo from './scroll-to'

NProgress.configure({ showSpinner: false })

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

// initialize things like header, footer
const oneTimeThings = () => {
  document.documentElement.classList.add('transitions-enabled')
  document.documentElement.classList.add(
    isMobile(window.navigator).any ? 'mobile' : 'desktop'
  )

  menu.init()

  proper100vh()

  stickyFooter.init()

  scrollProgress()

  const footer = document.querySelector('footer')
  if (footer) {
    withVue(footer, form)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const barbaContainer = document.querySelector('[data-barba="container"]')
  try {
    oneTimeThings()
    onPageLoad(barbaContainer || document.body)
  } catch (e) {
    console.error(e)
  }

  const preloader = document.querySelector('.preloader')
  if (preloader) {
    // loading animation after page refresh
    // 800ms delay to make sure animations will run smoothly
    // even without preloader video
    setTimeout(() => {
      loadingAnimation()
    }, 800)
  } else {
    scrollAnimations(document.body)
  }

  if (barbaContainer) {
    barba.init({
      // If server response is longer then 5s, page will reload completely.
      // You can set bigger values, but in case of long server response user should see something happens.
      timeout: 5000,
      transitions: [
        {
          beforeLeave() {
            NProgress.start()
            menu.toggle(false)
          },
          enter({ next }) {
            NProgress.done()
            onPageLoad(next.container)
            scrollAnimations(next.container)
            if (window.location.hash === '') {
              document.documentElement.scrollTop = 0
            }
          },
        },
      ],
    })
  }

  const smoothScrollLinks = document.querySelectorAll('.smooth-scroll-link')

  smoothScrollLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault() // Prevent the default behavior of the link
      const targetId = this.getAttribute('href').substring(1) // Get the target element ID from the href attribute
      smoothScrollTo(targetId)
    })
  })
})
